//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getNewEmail, sendEmail} from '@/api/index'

export default {
    mounted() {
        this.$vux.loading.show({
            text: '加载中...'
        });
        //获取本地存储的数据（COC查询结果）
        let
            t = this,
            coc = JSON.parse(sessionStorage.getItem('coc'));
        if (coc.deliveryDate) {
            let
                str = coc.deliveryDate,
                arr = str.split(' '),
                arrNew = arr.splice(0, 1);
            t.orderTime = arrNew.join(' ');
            sessionStorage.setItem('cocOrderTime', t.orderTime);
        }
        t.orderId = coc.deliveryNumber;
        sessionStorage.setItem('cocOrderId', t.orderId);
        coc.cocBaseDtos.forEach(item => {
            item.select = false;
            t.fileList.push(item);
        });
        //判断邮箱是获取的最新邮箱还是手动选择的邮箱
        console.log(121)
        if (!this.email) {
            //最新邮箱
            getNewEmail().then(res => {
                this.$vux.loading.hide();
                if (res.data.code === 0) {
                    t.emailAddress = res.data.data.email.emailAddress;
                } else {
                    t.$vux.toast.text(res.data.msg, 'middle');
                }
            });
        } else {
            //用户手动选择的邮箱
            this.emailAddress = this.email.emailAddress
            this.$vux.loading.hide();

        }
    },
    data() {
        return {
            orderId: '',
            orderTime: '',
            fileList: [],
            emailAddress: '填写邮箱',
            isAll: false,
            subjectBody: '',
        }
    },
    computed: {
        //用户选择的邮箱
        email() {
            return this.$store.state.email;
        }
    },
    methods: {
        //要发送的文件点选功能
        selectItem(index) {
            let t = this, item = t.fileList[index];
            item.select = !item.select;
            if (!item.select) this.isAll = false;
        },
        //要发送的文件全选功能
        selectAll() {
            if (!this.isAll) {
                this.fileList.map(item => {
                    item.select = true;
                    return item;
                });
                this.isAll = true
            } else {
                this.fileList.map(item => {
                    item.select = false;
                    return item;
                });
                this.isAll = false
            }
        },
        //点击“打开”查询产品合格证书
        openDetail(barcode, iccBatchNo, basetype) {
            let t = this;
            //把COC报告接口要的参数封装到data里通过路由传到下一个页面
            t.$router.push({
                path: '/certificateDetail',
                query: {
                    barcode,
                    iccBatchNo,
                    basetype
                }
            })
        },
        //选择其他邮箱
        selectEmail() {
            let t = this;
            t.$router.push('/selectEmail')
        },
        //发送邮件
        sendEmail() {
            let
                t = this,
                sendEmailList = t.fileList.filter(item => {
                    return item.select;
                });
            if (!sendEmailList.length) {
                t.$vux.toast.text('请选择需要发送的邮件', 'middle');
            } else {
                let basetype = sendEmailList[0].basetype;
                if (basetype === 0) {
                    t.subjectBody = '林德产品合格证-' + t.orderId + '-' + t.orderTime;
                } else {
                    t.subjectBody = sendEmailList.map(item => {
                        return `林德产品合格证-${item.barcode}`;
                    });
                }
                let htmlBody = sendEmailList.map(item => {
                    return escape('https://ecoa2.lindemobile.cn/pc/#/pc/certificateApprovalEmail?barcode=' + item.barcode + '&iccBatchNo=' + item.iccBatchNo + '&basetype=' + item.basetype + "\r\n")
                }).join('');
                this.$vux.loading.show({ text: '发送中...' });
                sendEmail({
                    htmlBody,
                    address: t.emailAddress,
                    subjectBody: t.subjectBody
                }).then(res => {
                    if (res.data.code === 0) {
                        this.$vux.loading.hide();
                        t.$vux.toast.text('发送成功', 'middle');
                    } else {
                        this.$vux.loading.hide();
                        t.$vux.toast.text(res.data.msg, 'middle');
                    }
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/COC/certificateResult.vue